import React from 'react';
import { AnchorIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full py-24 px-4 bg-white" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <div className="text-center mb-12" data-id="element-133">
          <span className="text-brand-purple font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-134">
            La solución
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-slate mb-6" data-id="element-135">
            El Método "Ancla Rápida"
          </h2>
          <p className="text-lg md:text-xl text-brand-navy max-w-2xl mx-auto leading-relaxed" data-id="element-136">
            Un protocolo basado en la estimulación mecánica del nervio vago. No
            necesitas "creer" en él; es biología pura.
          </p>
        </div>

        <div className="relative bg-gradient-to-br from-brand-lavender to-brand-lavenderDark/50 rounded-3xl p-8 md:p-12 shadow-lg border border-brand-lavenderDark/30 overflow-hidden" data-id="element-137">
          <div className="absolute top-0 right-0 -mt-8 -mr-8 text-brand-purple/10" data-id="element-138">
            <AnchorIcon className="w-48 h-48 transform rotate-12" aria-hidden="true" data-id="element-139" />
          </div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8" data-id="element-140">
            <div className="bg-white/80 p-4 rounded-full shadow-sm" data-id="element-141">
              <AnchorIcon className="w-10 h-10 text-brand-purple" aria-hidden="true" data-id="element-142" />
            </div>
            <p className="text-xl md:text-2xl font-serif text-brand-slate leading-relaxed font-medium" data-id="element-143">
              Al realizar una secuencia específica de respiración y anclaje
              sensorial, envías una señal física de seguridad que obliga a tu
              cerebro a apagar la descarga de adrenalina en menos de 10 minutos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}